import { render, staticRenderFns } from "./Kinanthropometry.vue?vue&type=template&id=382d049f&scoped=true"
import script from "./Kinanthropometry.vue?vue&type=script&lang=js"
export * from "./Kinanthropometry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d049f",
  null
  
)

export default component.exports